export const formatDate = (dateString: string, format: "short" | "long" = "short") => {
  if (!dateString) return "Not specified";

  const date = new Date(dateString);

  if (format === "short") {
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
